/* eslint-disable import/first */
import Druid from '@123/druid';
import type DialogClasses from '@123/druid/dist/Components/Window/Dialog/DialogClasses';

Druid.configure({
    form: {
        elements: ['input', 'textarea', 'select'],
        fileInputs: Druid.DEFAULT_FILE_INPUTS,
        className: 'dr-form',
        invalidInputClass: 'dr-form--invalid-input',
    },
    dialog: {
        frameTemplate: (classes?: DialogClasses): string => `
            <div class="${classes?.frame ?? 'dr-dialog-frame'}" data-test="popup">
                <div class="${classes?.header ?? 'dr-header'}" data-role="header">
                    <span class="${classes?.title ?? 'dr-title'}" data-role="title"></span>
                    <span class="${classes?.icon ?? 'dr-icon'}" data-test="popup-icon"></span>
                    <span class="${classes?.close ?? 'dr-close'}" data-role="close"></span>
                </div>
                <div class="${classes?.wrapper ?? 'dr-wrapper'}">
                    <div class="${classes?.content ?? 'dr-content'}" data-role="content"></div>
                    <div class="${classes?.footer ?? 'dr-footer'}" data-role="footer"></div>
                </div>
            </div>`,
    },
    translations: {
        mandatoryField: '%%LANG_MANDATORY%%',
        errorInputInvalid: '%%LANG_ERROR%%',
    },
    scrollLock: false,
});

Druid.addDefaultRequestHeader('X-Requested-With', 'XMLHttpRequest');

import ViewFinder from '@123/druid/dist/Framework/View/ViewFinder';
import ApplicationView from '@Application/ApplicationView';
// start the ApplicationView
new ViewFinder(Druid.getViewFramework()).getView(document.body, ApplicationView);

/* include WebComponents */
import '@Module/Group/Component/QuickFilter/WebComponent/QuickFilterInput';
import '@Component/Carousel/Component/SliderControls';
import '@Component/Slider/FixedSlider';
import '@Component/Carousel/Carousel';
import '@Component/ElementList/Component/ElementListCollapser';
import '@Component/ElementList/ElementList';
import '@Component/Dropdown/Dropdown';
import '@Component/Input/Stepper';
import '@Component/Mollie/Input/MollieInput';
import '@Component/Input/InputDropdown/InputDropdown';
import '@Component/Google/Autocomplete/GoogleAutocomplete';

/* include injectables */
import '@Service/Scrollable/Scrollable';
import '@Application/ApplicationConfig';
import '@Service/Message/MessageBus';
import '@Service/Config/Config';
